module.exports = __webpack_public_path__ + "acafeac8dbde449925d03468defb8ce3.svg";